import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { polyfillCss } from "@store/theme/polyfills";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(sortSelectStyles, {
    select: {
        labelProps: {
            css: css``,
        },
        cssOverrides: {
            formField: css`
                justify-content: flex-end;
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: [null, null, null, "300px", null], properties: ["width"] }],
                        mediaOptions.min,
                    )}
            `,
            formInputWrapper: polyfillCss`
                justify-content: flex-end;
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["unset", null, null, "inherit", null], properties: ["width"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
});
